import React from "react"
import Grid from "../../grid"
import { H2, P } from "../../typography"
import * as Fields from "./fields"
import { validVideoUrl } from "../../../utils/stringHelpers"
import { Fieldset, CustomFlex, Div, VideoContainer } from "./styles"
import { Img } from "../photos-and-videos/styles"
import VideoPlayer from "../../video-player"

const fieldTypes = {
  text: Fields.Text,
  textarea: Fields.Text,
  number: Fields.Number,
  radio: Fields.Text,
  select: Fields.Text,
  date: Fields.Date,
  default_date: Fields.Date,
  university: Fields.Text,
  checkbox: Fields.Checkbox,
  large_textarea: Fields.Text,
  multi_text: Fields.MultiText,
  url: Fields.Text,
  roles: Fields.Roles
}

const isEmbedVideoUrl = (field) => {
  return field.field_type == "url" && validVideoUrl(field.answer)
}

const defaultMaxWidth = 250
const dynamicHeight = (videoWidth, videoHeight) => {
  const aspectRatio = videoHeight / videoWidth
  const dynamicHeight = defaultMaxWidth * aspectRatio
  return dynamicHeight
}

const Form = ({
  fieldsets,
  employer,
  onRequestInterview,
  onInterview,
  bookInterviewSelectedSkill,
  bookInterviewSection,
  initialSection
}) => (
  <Grid gap="32px">
    {fieldsets &&
      fieldsets
        .filter(
          (fieldset) =>
            fieldset.fields.length > 0 && fieldset.fields.some((field) => field.answer || field.field_type === "roles")
        )
        .map((fieldset, index) => (
          <Fieldset
            className={`fieldset_${fieldset.name}`}
            key={`fieldset_${index}`}
            last={fieldsets.length === index + 1}
            video={!!fieldset.intro_video_id}
            marginless
          >
            <Grid gap="1.5rem">
              <H2 variant="primary" marginless profile>
                {fieldset.legend}
              </H2>

              <CustomFlex header={!!fieldset.header_photo}>
                <Div profileLayout={fieldset.profile_layout}>
                  {fieldset.fields.map((field, index2) => {
                    let FieldType
                    if (isEmbedVideoUrl(field)) {
                      FieldType = Fields.Video
                    } else {
                      FieldType = fieldTypes[field.field_type]
                    }

                    // skip the title if it's the same as the fieldset
                    field.label = fieldset.legend == field.label ? "" : field.label
                    return FieldType ? (
                      <FieldType
                        key={`fieldset_${index}_field_${index2}`}
                        {...field}
                        employer={employer}
                        onRequestInterview={onRequestInterview}
                        onInterview={onInterview}
                        bookInterviewSelectedSkill={bookInterviewSelectedSkill}
                        bookInterviewSection={bookInterviewSection}
                        initialSection={initialSection}
                      />
                    ) : (
                      <P variant="content">error</P>
                    )
                  })}
                </Div>

                {!!!fieldset.intro_video_id && !!fieldset.header_photo && (
                  <Div profileLayout={fieldset.profile_layout} style={{ maxHeight: "320px", overflow: "hidden" }}>
                    <Img
                      src={fieldset.header_photo}
                      alt={fieldset.legend}
                      style={{ cursor: "default", objectFit: "cover", width: "100%", height: "100%" }}
                    />
                  </Div>
                )}
              </CustomFlex>
            </Grid>

            {!!fieldset.intro_video_id && (
              <VideoContainer
                style={{
                  width: defaultMaxWidth,
                  height: dynamicHeight(fieldset.intro_video_width, fieldset.intro_video_height)
                }}
              >
                <VideoPlayer
                  videoId={fieldset.intro_video_id}
                  displayEmployerLabel={true}
                  fullSize={true}
                  width={defaultMaxWidth}
                  height={dynamicHeight(fieldset.intro_video_width, fieldset.intro_video_height)}
                />
              </VideoContainer>
            )}
          </Fieldset>
        ))}
  </Grid>
)

export default Form
